import { createSlice } from '@reduxjs/toolkit';

import { reducers } from './reducers';
import { SliceState } from './slice-state';

const initialState: SliceState = {
    resolvedMap: {},
};

const resolverSlice = createSlice({
    name: 'resolver',
    initialState,
    reducers,
});

export const ResolverSliceReducer = resolverSlice.reducer;

export const { setResolvedValue, clearResolvedValue } = resolverSlice.actions;
